// extracted by mini-css-extract-plugin
export default {"skillWrapper":"Skill_skillWrapper__oiiBe","name":"Skill_name__ysteO","skillList":"Skill_skillList__BImg0","skill":"Skill_skill__ZTha+"};